module.exports = __webpack_public_path__ + "static/media/calendar-clock.0ea79176.svg";